import { createRoot } from 'react-dom/client';
import { Site } from './site/Site';
import './styles/app.css';

createRoot(document.getElementById('root')!).render(<Site />);
